module.exports = __webpack_public_path__ + "static/img/miles_pictgrid13_920x857.c78e45e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/miles_pictgrid13_920x857.jpg
// module id = P2kT
// module chunks = 0